import { useState } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Box,
    Typography,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import CreateSceneSize from './CreateSceneSize';

export default function AddScenarioButton({ addNewScenario, scenarioName, setScenarioName }) {
    const [open, setOpen] = useState(false);
    // const [containerId, setContainerId] = useState('');
    const [containerSize, setContainerSize] = useState('');


    const { id } = useParams();


    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setScenarioName('');
    };


    return (
        <>
            <Button variant="contained" sx={{ mt: 2 }} onClick={handleOpen}>
                Dodaj stację
            </Button>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Dodaj nową stację</DialogTitle>

                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Nazwa stacji"
                        fullWidth
                        value={scenarioName}
                        onChange={(e) => setScenarioName(e.target.value)}
                    />
                    {/* <TextField
                        autoFocus
                        margin="dense"
                        label="Id kontenera"
                        fullWidth
                        value={containerId}
                        onChange={(e) => setContainerId(e.target.value)}
                    /> */}
                    <Box sx={{ mt: 2, justifyItems: "center" }}>
                        <Typography variant="h6" align="center" color="textSecondary">
                            Ustaw rozmiar sceny
                        </Typography>
                        <CreateSceneSize setContainerSize={setContainerSize} />
                    </Box>
                </DialogContent>


                <DialogActions>
                    <Button onClick={handleClose}>Anuluj</Button>
                    <Button variant="contained" onClick={() => { addNewScenario(id, containerSize); handleClose(); }}>
                        Dodaj
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
